// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../common.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._2wF9X2G0x{text-align:center;display:flex;flex-direction:column;width:100%}._2wF9X2G0x ._7vMIsa3jx{align-items:center;display:flex;flex-direction:column}._6lqnQ6NBx{justify-content:center;flex:7;margin-bottom:100px}._1vIe8cXPx{flex:1}._4e9m33Z5x{margin-top:50px}._5QxMhVW0x{font-size:20px;margin:10px;color:#9C9C9C;white-space:pre-line}._11ObJPdGx{font-weight:bold;font-size:22px;padding:10px;color:#303030}.qzG3Wpg7x{color:#F56D4F}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_2wF9X2G0x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["centered"] + "",
	"child-container": "_7vMIsa3jx",
	"childContainer": "_7vMIsa3jx",
	"content-container": "_6lqnQ6NBx _7vMIsa3jx",
	"contentContainer": "_6lqnQ6NBx _7vMIsa3jx",
	"logo-container": "_1vIe8cXPx _7vMIsa3jx",
	"logoContainer": "_1vIe8cXPx _7vMIsa3jx",
	"logo": "_4e9m33Z5x",
	"message": "_5QxMhVW0x",
	"app-name": "_11ObJPdGx",
	"appName": "_11ObJPdGx",
	"error": "qzG3Wpg7x _5QxMhVW0x"
};
module.exports = exports;
